/**
 * LedgerThread — the faint vertical thread SVG behind the card list (mock `.list__thread`): the
 * brand cue that the cards hang off one thread. Thread gradient, stroke 2, ~.5 opacity, below the
 * cards, pointer-events none, decorative (`aria-hidden`).
 */
export function LedgerThread() {
  return (
    <svg
      className="pointer-events-none absolute left-5 top-3.5 -z-0 h-[calc(100%-20px)] w-11 opacity-50"
      viewBox="0 0 44 520"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="bmwThread" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#7A9278" />
          <stop offset=".5" stopColor="#E7A987" />
          <stop offset="1" stopColor="#D9704A" />
        </linearGradient>
      </defs>
      <path
        d="M22 10 C 6 70, 38 130, 22 190 C 8 250, 36 310, 22 370 C 10 430, 32 480, 22 510"
        fill="none"
        stroke="url(#bmwThread)"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
